import styled from 'styled-components'
import { print, screen } from 'utilities/styled'
import CompetenceProfileStatus from 'pages/competence/components/profile-status'
import { tiptapContentCss } from 'components/tiptap/s'

export const ProfileStatus = styled(CompetenceProfileStatus)`
    display: block;

    margin-block-end: 16px;
`

export const Description = styled.div`
    ${tiptapContentCss}

    > :last-child {
        margin-block-end: 0 !important;
    }

    ${screen`
        a {
            overflow-wrap: break-word;
        }

        .highlight,
        .match {
            all: unset;
        }
    `}

    ${print`
        .rough-annotation {
            display: none;
        }
    `}
`